"use client";
import { ChevronUp } from "@/components/newIcons/ChevronUp";
import clsx from "clsx";
import { useState } from "react";
import type { Travel } from "../../getTravel";
import { Columns } from "./Column";

type Props = {
  travel: Travel;
};
export const Reviews = ({ travel }: Props) => {
  const [showAll, setShowAll] = useState(false);

  const midpoint = Math.ceil(travel.reviews.length / 2);
  const firstColumn = travel.reviews.slice(0, midpoint);
  const secondColumn = travel.reviews.slice(midpoint);

  return (
    <>
      <h2 className="text-primary text-[22px] leading-7 lg:text-[26px] lg:leading-8 font-bold mt-8">
        L'avis des voyageurs Intermèdes pour ce voyage
      </h2>
      <div className="grid grid-cols-1 gap-4 mt-4 md:grid-cols-2 items-start">
        <Columns reviews={firstColumn} showAll={showAll} />
        <Columns reviews={secondColumn} showAll={showAll} />
      </div>
      {travel.reviews.length > 4 && (
        <div className="flex items-center justify-center mt-6">
          <div
            className="flex items-center justify-center space-x-[6px] text-[#C1B1AC] hover:text-primary cursor-pointer"
            onClick={() => setShowAll(!showAll)}
          >
            <p className="text-sm font-medium">{showAll ? "Masquer tous les avis" : "Voir tous les avis"}</p>
            <ChevronUp
              className={clsx("w-4 h-4", {
                "rotate-180": !showAll,
              })}
            />
          </div>
        </div>
      )}
    </>
  );
};
